<template>
<div class="wenhui-cases-container">
    <!-- 科技感案例Banner -->
    <div class="tech-cases-banner">
        <div class="banner-content">
            <h1>技术案例</h1>
            <p>创新驱动 · 技术赋能</p>
            <div class="tech-particles">
                <div class="particle" v-for="i in 30" :key="i" 
                     :style="{
                         left: `${Math.random()*100}%`,
                         top: `${Math.random()*100}%`,
                         width: `${Math.random()*8+2}px`,
                         height: `${Math.random()*8+2}px`,
                         animationDelay: `${Math.random()*2}s`
                     }"></div>
            </div>
        </div>
    </div>

    <!-- 案例展示区 -->
    <div class="section tech-cases-section">
        <div class="container">
            <h2 class="section-title">成功<span class="tech-highlight">案例</span></h2>
            <p class="section-subtitle">200+企业信赖的技术解决方案</p>

            <el-tabs v-model="activeCategory" @tab-click="handleTabChange" class="tech-tabs">
                <el-tab-pane v-for="category in categories" :key="category.id" :label="category.name" :name="category.id">
                    <el-row :gutter="20">
                        <el-col v-for="caseItem in filteredCases" :key="caseItem.id" :xs="24" :sm="12" :md="8" :lg="6">
                            <div class="tech-case-card" @click="showCaseDetail(caseItem)">
                                <div class="tech-case-image">
                                    <img :src="caseItem.image" :alt="caseItem.title">
                                    <div class="tech-case-overlay">
                                        <h3>{{ caseItem.title }}</h3>
                                        <p>{{ caseItem.subtitle }}</p>
                                        <div class="tech-case-tags">
                                            <span v-for="(tag, i) in caseItem.tags" :key="i">{{ tag }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

    <!-- 案例详情弹窗 - 科技风格 -->
    <el-dialog :title="currentCase.title" :visible.sync="dialogVisible" width="80%" class="tech-case-dialog">
        <div class="tech-case-detail">
            <el-row :gutter="40">
                <el-col :span="12">
                    <div class="tech-detail-image">
                        <img :src="currentCase.image" :alt="currentCase.title">
                        <div class="tech-stack">
                            <div class="tech-stack-item" v-for="(tech, index) in currentCase.techStack" :key="index">
                                <img :src="tech.logo" :alt="tech.name">
                                <span>{{ tech.name }}</span>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="tech-detail-content">
                        <h3>{{ currentCase.title }}</h3>
                        <p class="tech-meta">行业: {{ currentCase.industry }} | 周期: {{ currentCase.duration }}</p>
                        <el-divider class="tech-divider"></el-divider>
                        <div class="tech-detail-text">
                            <h4><i class="el-icon-document"></i> 项目背景</h4>
                            <p>{{ currentCase.background }}</p>
                        </div>
                        <el-divider class="tech-divider"></el-divider>
                        <div class="tech-detail-text">
                            <h4><i class="el-icon-cpu"></i> 解决方案</h4>
                            <p>{{ currentCase.solution }}</p>
                        </div>
                        <el-divider class="tech-divider"></el-divider>
                        <div class="tech-results">
                            <h4><i class="el-icon-success"></i> 项目成果</h4>
                            <el-row :gutter="20">
                                <el-col :span="12" v-for="(result, index) in currentCase.results" :key="index">
                                    <div class="tech-result-item">
                                        <i class="el-icon-check"></i> {{ result }}
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="tech-dialog-footer">
            <el-button class="tech-close-btn" @click="dialogVisible = false">关闭</el-button>
            <el-button class="tech-consult-btn" type="primary" @click="handleConsult">咨询类似方案</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    name: 'WenhuiCasesPage',
    data() {
        return {
            activeCategory: 'education',
            dialogVisible: false,
            currentCase: {
                title: '',
                image: '',
                industry: '',
                duration: '',
                background: '',
                solution: '',
                results: [],
                techStack: []
            },
            categories: [
                {
                    id: 'education',
                    name: '教育行业'
                },
                {
                    id: 'finance',
                    name: '金融科技'
                },
                {
                    id: 'healthcare',
                    name: '医疗健康'
                },
                {
                    id: 'ecommerce',
                    name: '电子商务'
                }
            ],
            cases: [
                {
                    id: 1,
                    category: 'education',
                    title: '智慧校园平台',
                    subtitle: '某高校数字化校园解决方案',
                    image: require('@/assets/images/base.png'),
                    industry: '高等教育',
                    duration: '6个月',
                    tags: ['SaaS', '云计算', '大数据'],
                    techStack: [
                        {name: 'Java', logo: require('@/assets/images/base.png')},
                        {name: 'Spring Cloud', logo: require('@/assets/images/base.png')},
                        {name: 'Vue', logo: require('@/assets/images/base.png')},
                        {name: 'MySQL', logo: require('@/assets/images/base.png')}
                    ],
                    background: '某高校希望建设统一的数字化校园平台，整合教务管理、学生服务、校园生活等功能，解决信息孤岛问题，提升管理效率和服务质量。',
                    solution: '我们采用微服务架构设计，开发了包含教务管理、在线学习、校园服务等模块的一站式平台。前端使用Vue实现多端适配，后端采用Spring Cloud实现服务治理，通过API网关统一接入，使用Docker实现容器化部署。',
                    results: [
                        '实现全校90%业务流程数字化',
                        '师生服务效率提升60%',
                        '系统响应时间<500ms',
                        '支持5000并发用户'
                    ]
                },
                {
                    id: 2,
                    category: 'finance',
                    title: '金融风控系统',
                    subtitle: '某银行信贷风险评估平台',
                    image: require('@/assets/images/base.png'),
                    industry: '银行业',
                    duration: '8个月',
                    tags: ['大数据', '机器学习', '风控'],
                    techStack: [
                        {name: 'Python', logo: require('@/assets/images/base.png')},
                        {name: 'Spark', logo: require('@/assets/images/base.png')},
                        {name: 'Hadoop', logo: require('@/assets/images/base.png')},
                        {name: 'TensorFlow', logo: require('@/assets/images/base.png')}
                    ],
                    background: '某商业银行需要构建智能化信贷风险评估系统，以提升贷款审批效率和风险识别能力，应对互联网金融的挑战。',
                    solution: '我们开发了基于大数据和机器学习的风控平台，整合了客户征信数据、交易行为数据等多维度信息，构建了风险评估模型，实现了自动化审批流程和实时风险监控。',
                    results: [
                        '审批效率提升80%',
                        '坏账率降低35%',
                        '支持实时风险评估',
                        '日处理贷款申请5000+'
                    ]
                },
                {
                    id: 3,
                    category: 'healthcare',
                    title: '互联网医院平台',
                    subtitle: '某三甲医院线上诊疗系统',
                    image: require('@/assets/images/base.png'),
                    industry: '医疗健康',
                    duration: '5个月',
                    tags: ['小程序', '在线诊疗', '电子处方'],
                    techStack: [
                        {name: 'Node.js', logo: require('@/assets/images/base.png')},
                        {name: 'React', logo: require('@/assets/images/base.png')},
                        {name: 'MongoDB', logo: require('@/assets/images/base.png')},
                        {name: '微信小程序', logo: require('@/assets/images/base.png')}
                    ],
                    background: '某三甲医院希望拓展互联网医疗服务，为患者提供线上问诊、电子处方、检查预约等服务，缓解线下就诊压力。',
                    solution: '我们开发了包含医生端、患者端、管理端的互联网医院平台，实现了在线问诊、电子处方、检查预约、报告查询等核心功能，并与医院HIS系统深度集成。',
                    results: [
                        '线上问诊量日均200+',
                        '患者候诊时间减少60%',
                        '处方流转效率提升70%',
                        '患者满意度提升40%'
                    ]
                },
                {
                    id: 4,
                    category: 'ecommerce',
                    title: '跨境电商平台',
                    subtitle: '某出口企业全球电商系统',
                    image: require('@/assets/images/base.png'),
                    industry: '电子商务',
                    duration: '4个月',
                    tags: ['多语言', '支付集成', '物流'],
                    techStack: [
                        {name: 'PHP', logo: require('@/assets/images/base.png')},
                        {name: 'Laravel', logo: require('@/assets/images/base.png')},
                        {name: 'Vue', logo: require('@/assets/images/base.png')},
                        {name: '支付系统', logo: require('@/assets/images/base.png')}
                    ],
                    background: '某出口制造企业希望建立自主跨境电商平台，直接面向全球消费者销售产品，减少中间环节，提升利润率。',
                    solution: '我们开发了支持多语言、多货币的跨境电商平台，整合了PayPal、信用卡等多种支付方式，对接了国际物流系统，实现了从下单到交付的全流程管理。',
                    results: [
                        '支持10种语言展示',
                        '整合5种支付方式',
                        '订单处理效率提升50%',
                        '月销售额突破$50万'
                    ]
                },
                {
                    id: 5,
                    category: 'education',
                    title: '在线教育平台',
                    subtitle: '某培训机构线上学习系统',
                    image: require('@/assets/images/base.png'),
                    industry: '教育培训',
                    duration: '3个月',
                    tags: ['直播', '点播', '在线测试'],
                    techStack: [
                        {name: 'Java', logo: require('@/assets/images/base.png')},
                        {name: 'Spring Boot', logo: require('@/assets/images/base.png')},
                        {name: 'WebRTC', logo: require('@/assets/images/base.png')},
                        {name: 'Redis', logo: require('@/assets/images/base.png')}
                    ],
                    background: '某职业培训机构需要将线下课程转移到线上，实现直播授课、录播回看、在线测试等功能，满足学员随时随地学习的需求。',
                    solution: '我们开发了基于WebRTC的实时互动教学系统，支持直播授课、屏幕共享、白板互动等功能，同时提供课程点播、在线测试、学习进度跟踪等辅助功能。',
                    results: [
                        '支持1000人同时在线',
                        '直播延迟<500ms',
                        '课程完成率提升45%',
                        '学员满意度达95%'
                    ]
                },
                {
                    id: 6,
                    category: 'finance',
                    title: '区块链供应链金融',
                    subtitle: '某集团供应链金融平台',
                    image: require('@/assets/images/base.png'),
                    industry: '供应链金融',
                    duration: '6个月',
                    tags: ['区块链', '智能合约', '供应链'],
                    techStack: [
                        {name: 'Go', logo: require('@/assets/images/base.png')},
                        {name: 'Hyperledger', logo: require('@/assets/images/base.png')},
                        {name: 'Docker', logo: require('@/assets/images/base.png')},
                        {name: 'Kubernetes', logo: require('@/assets/images/base.png')}
                    ],
                    background: '某大型制造集团希望利用区块链技术优化供应链金融服务，解决中小企业融资难问题，同时降低集团供应链风险。',
                    solution: '我们基于Hyperledger Fabric开发了区块链供应链金融平台，实现了应收账款确权、流转、融资的全流程上链，通过智能合约自动执行交易规则。',
                    results: [
                        '融资审批时间缩短70%',
                        '交易透明度提升100%',
                        '年融资规模达5亿元',
                        '坏账率降低至0.5%'
                    ]
                }
            ]
        }
    },
    computed: {
        filteredCases() {
            return this.cases.filter(item => item.category === this.activeCategory)
        }
    },
    methods: {
        handleTabChange(tab) {
            this.activeCategory = tab.name
        },
        showCaseDetail(caseItem) {
            this.currentCase = {
                ...caseItem
            }
            this.dialogVisible = true
        },
        handleConsult() {
            this.dialogVisible = false
            this.$router.push('/contact')
        }
    }
}
</script>

<style lang="scss" scoped>
.wenhui-cases-container {
    padding-top: 80px;
    background-color: #f5f7fa;

    .tech-cases-banner {
        height: 500px;
        background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        position: relative;
        overflow: hidden;

        .banner-content {
            position: relative;
            z-index: 2;
            
            h1 {
                font-size: 60px;
                margin: 0 0 15px;
                font-weight: 700;
                text-shadow: 0 2px 10px rgba(0,0,0,0.3);
            }

            p {
                font-size: 24px;
                margin: 0;
                opacity: 0.9;
            }
        }

        .tech-particles {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .particle {
                position: absolute;
                background: rgba(255,255,255,0.5);
                border-radius: 50%;
                animation: float 5s infinite ease-in-out;
                opacity: 0.7;
            }
        }
    }

    .tech-cases-section {
        padding: 80px 0;
        background-color: #fff;
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .section-title {
        text-align: center;
        font-size: 42px;
        color: #333;
        margin-bottom: 15px;
        position: relative;
        font-weight: 700;

        .tech-highlight {
            color: #409EFF;
            position: relative;
            
            &::after {
                content: '';
                position: absolute;
                bottom: 5px;
                left: 0;
                width: 100%;
                height: 10px;
                background: rgba(64, 158, 255, 0.2);
                z-index: -1;
            }
        }
    }

    .section-subtitle {
        text-align: center;
        font-size: 20px;
        color: #666;
        margin-bottom: 50px;
    }

    .tech-tabs {
        /deep/ .el-tabs__nav-wrap::after {
            background-color: #eee;
        }

        /deep/ .el-tabs__item {
            font-size: 18px;
            padding: 0 25px;
            height: 60px;
            line-height: 60px;
            font-weight: 500;

            &.is-active {
                color: #409EFF;
            }
        }

        /deep/ .el-tabs__active-bar {
            background-color: #409EFF;
            height: 3px;
        }
    }

    .tech-case-card {
        margin-bottom: 30px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            transform: translateY(-10px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        }

        .tech-case-image {
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            height: 250px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
                transition: transform 0.5s;
            }

            .tech-case-overlay {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 20px;
                background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
                color: #fff;

                h3 {
                    margin: 0 0 5px;
                    font-size: 18px;
                }

                p {
                    margin: 0 0 10px;
                    font-size: 14px;
                    opacity: 0.8;
                }
            }

            .tech-case-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 5px;

                span {
                    background: rgba(64, 158, 255, 0.9);
                    color: #fff;
                    padding: 2px 8px;
                    border-radius: 10px;
                    font-size: 12px;
                }
            }

            &:hover img {
                transform: scale(1.1);
            }
        }
    }

    .tech-case-dialog {
        /deep/ .el-dialog {
            border-radius: 12px;
            overflow: hidden;
            max-width: 1200px;

            &__header {
                background-color: #f5f7fa;
                padding: 20px;
                border-bottom: 1px solid #eee;
            }

            &__body {
                padding: 30px;
            }

            &__footer {
                padding: 20px;
                text-align: center;
                border-top: 1px solid #eee;
            }
        }

        .tech-case-detail {
            .tech-detail-image {
                img {
                    width: 100%;
                    border-radius: 8px;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                    margin-bottom: 20px;
                }

                .tech-stack {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 15px;

                    .tech-stack-item {
                        display: flex;
                        align-items: center;
                        background: #f5f7fa;
                        padding: 8px 12px;
                        border-radius: 20px;
                        font-size: 12px;

                        img {
                            width: 20px;
                            height: 20px;
                            margin-right: 8px;
                        }
                    }
                }
            }

            .tech-detail-content {
                h3 {
                    font-size: 24px;
                    margin: 0 0 10px;
                    color: #333;
                }

                .tech-meta {
                    color: #666;
                    font-size: 14px;
                    margin: 0 0 20px;
                }

                .tech-divider {
                    margin: 20px 0;
                    background-color: #ebeef5;
                }

                .tech-detail-text {
                    margin-bottom: 20px;

                    h4 {
                        font-size: 18px;
                        color: #333;
                        margin: 0 0 15px;
                        display: flex;
                        align-items: center;

                        i {
                            margin-right: 8px;
                            color: #409EFF;
                        }
                    }

                    p {
                        color: #666;
                        line-height: 1.8;
                        margin: 0;
                    }
                }

                .tech-results {
                    h4 {
                        font-size: 18px;
                        color: #333;
                        margin: 0 0 15px;
                        display: flex;
                        align-items: center;

                        i {
                            margin-right: 8px;
                            color: #67C23A;
                        }
                    }

                    .tech-result-item {
                        background: #f5f7fa;
                        padding: 10px;
                        border-radius: 4px;
                        margin-bottom: 10px;
                        color: #666;
                        font-size: 14px;
                        display: flex;
                        align-items: center;

                        i {
                            color: #67C23A;
                            margin-right: 8px;
                            font-size: 16px;
                        }
                    }
                }
            }
        }

        .tech-dialog-footer {
            display: flex;
            justify-content: center;
            gap: 30px;

            .tech-close-btn {
                width: 120px;
                height: 42px;
                border-radius: 21px;
                border: 1px solid #dcdfe6;
                background: #fff;
                color: #606266;
                font-size: 16px;
                transition: all 0.3s;

                &:hover {
                    color: #409EFF;
                    border-color: #409EFF;
                    background: #fff;
                }
            }

            .tech-consult-btn {
                width: 120px;
                height: 42px;
                border-radius: 21px;
                background: #409EFF;
                border: none;
                color: #fff;
                font-size: 16px;
                transition: all 0.3s;

                &:hover {
                    background: #66b1ff;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }
    }

    @media (max-width: 992px) {
        .tech-case-detail {
            .el-col {
                &:first-child {
                    margin-bottom: 30px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .tech-cases-banner {
            height: 350px;
            
            h1 {
                font-size: 36px;
            }

            p {
                font-size: 18px;
            }
        }

        .tech-tabs {
            /deep/ .el-tabs__item {
                font-size: 16px;
                padding: 0 15px;
            }
        }

        .tech-case-dialog {
            /deep/ .el-dialog {
                width: 90% !important;

                &__body {
                    padding: 20px;
                }
            }

            .tech-dialog-footer {
                flex-direction: column;
                gap: 15px;

                .tech-close-btn,
                .tech-consult-btn {
                    width: 100%;
                }
            }
        }
    }

    @media (max-width: 576px) {
        .tech-cases-banner {
            height: 300px;
            
            h1 {
                font-size: 28px;
            }

            p {
                font-size: 16px;
            }
        }

        .tech-tabs {
            /deep/ .el-tabs__item {
                font-size: 14px;
                padding: 0 10px;
            }
        }
    }
}

@keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-20px); }
}
</style>